module.exports = __webpack_public_path__ + "static/media/no-wifi.025de639.png";